module.exports = "form {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 400px;\n  border-radius: 4px;\n  border: solid 1px #e6eaee;\n  padding: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main